export {default as color, rgb, hsl} from "./src/color";
export {default as lab, hcl} from "./src/lab";
export {default as cubehelix} from "./src/cubehelix";



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-color/index.js
// module id = ../../../../d3-color/index.js
// module chunks = 4